import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ServiceFulfillmentComponent } from '../service-fulfillment/service-fulfillment.component';
import { UserStateService } from '../../user/shared/services/user-state/user-state.service';
import { UserRole } from '../../../core/enums/users/role';
import { ServicesAndFilingsComponent } from '../services-and-filings/services-and-filings.component';

@Component({
    selector: 'app-service-fulfillment-container',
    imports: [ServiceFulfillmentComponent, ServicesAndFilingsComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './service-fulfillment-container.component.html',
})
export class ServiceFulfillmentContainerComponent {
    constructor(private readonly userStateService: UserStateService) {}

    /**
     * Determines if the current user has a customer role.
     */
    isCustomerView(): boolean {
        return this.userStateService.getRole() === UserRole.Customer;
    }
}
